import * as React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";
import UnderLine from "../../components/AnimatedUnderLine";
import { Auth } from "aws-amplify";
import Colors from "../../utilities/Color.js";
import getEnvVars from "../../enviroment";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GenericButton from "../../components/GenericButton";

const awsConfig = getEnvVars().awsConfig;
Auth.configure(awsConfig);

export default function LoginModeChoiceSocialScreen() {
  const navigation = useNavigation();

  return (
    <View style={GlobalStyles.containerMB}>
      <ScrollView>
        <View style={GlobalStyles.bodyContainerT}>
          <View style={styles.HbuttonBar}>
            <TouchableOpacity
              style={styles.HbackButtonStyle}
              onPress={() => navigation.navigate("LoginModeChoice")}
            >
              <Ionicons
                name="md-arrow-back"
                size={20}
                style={styles.HbackArrow}
              />
            </TouchableOpacity>
            <View>
              <Text style={styles.HTextStyle}>LOG IN</Text>
            </View>
            <View style={styles.HbackButtonStyle}></View>
          </View>
          <View style={styles.container}>
            <Text style={styles.headerTextStyle}>
              Social Log In
            </Text>
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>
              Only continue if you have already
              registered an Aura account using
              Apple ID or Google.
            </Text>


            <View style={{ marginTop: 25 }}>
              <GenericButton
                buttonText="CONTINUE WITH APPLE ID"
                onPress={async () => {
                  const savedLogin = {
                    mode: 's'
                  }
                  await AsyncStorage.setItem('loginMemory', JSON.stringify(savedLogin));
                  Auth.federatedSignIn({ provider: "SignInWithApple" });
                }
                }
              />
            </View>

            <View style={{ marginTop: 50 }}>
              <GenericButton
                buttonText="CONTINUE WITH GOOGLE"
                onPress={async () => {
                  const savedLogin = {
                    mode: 's'
                  }
                  await AsyncStorage.setItem('loginMemory', JSON.stringify(savedLogin));
                  Auth.federatedSignIn({ provider: "Google" })
                }}
              />
            </View>

            <View style={{ marginTop: 150 }}>
              <GenericButton
                buttonColor={null}
                borderWidth={1}
                borderColor={Colors.DARKGRAY}
                buttonText='LOGIN ANOTHER WAY'
                onPress={() => navigation.navigate("LoginModeChoice")}
              />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  linkStyle: {
    marginBottom: 25,
    marginTop: 35,
  },
  buttonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  container: {
    paddingTop: 20,
    marginLeft: 30,
    marginRight: 30,
    maxWidth: 480,
    alignSelf: "center"
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 20
  },
  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 25,
  },
  HbuttonBarConf: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
  },
  HbackArrow: {
    color: "#fff",
  },
  HbackArrowBlack: {
    color: "#000",
  },
  HbackButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },
  buttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },
  headerTextStyle: {
    color: Colors.WHITE,
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "center",
    marginBottom: 10
  }
});
